export const MAX_SWAP_FEE_BPS = 1000;

// If this list gets longer than 10 items, move it to a database.
export const referrers: Record<string, { address: string; name: string }> = {
  dexscreener: {
    address: '0x48b51287FB5281EA0913100809C3b7f1649C7996',
    name: 'DEX Screener',
  },
  clanker: {
    address: '0x1eaf444ebDf6495C57aD52A04C61521bBf564ace',
    name: 'Clanker',
  },
  gdupi: {
    address: '0x78B2De47FE499e0a6f7A67DBF965B8Ec765D2D9d',
    name: 'GDUPI',
  },
};
